import { hot } from 'react-hot-loader/root';
import * as React from 'react';
import '@patternfly/react-core/dist/styles/base.css';
import '@patternfly/react-styles/css/utilities/Spacing/spacing.css';
import '@patternfly/react-styles/css/utilities/Sizing/sizing.css';
import '@patternfly/react-styles/css/utilities/Alignment/alignment.css';
import '@patternfly/react-styles/css/utilities/BackgroundColor/BackgroundColor.css';
import '@patternfly/react-styles/css/utilities/Text/text.css';
import '@patternfly/react-styles/css/utilities/Float/float.css'
import { BrowserRouter as Router } from 'react-router-dom';
import { AppLayout } from '@app/AppLayout/AppLayout';
import { AppRoutes } from '@app/routes';
import '@app/app.css';
import { ToastProvider } from '@app/Context/ToastNotificationContext';
import { UserProvider } from '@app/Context/UserContext';
import { NavigationProvider } from './Context/NavigationContext';
import { NotificationProvider } from './Context/NotificationContext';
import { PageRouteProvider } from './Context/PageRouteContext';
import { AnalyticsWrapper } from './utils/AnalyticsWrapper';
import { Provider, ErrorBoundary } from '@rollbar/react';
import AppSettings from './utils/AppSettings';

const rollbarConfig = {
  accessToken: AppSettings.getRollbarAccessToken(),
  environment: AppSettings.getRollbarEnvironment()
};

// Make global gtag function visible to typescript
declare global {
  interface Window {
    gtag: (...args) => {};
  }
}

const App: React.FunctionComponent = () => {

  return (
    <Provider config={rollbarConfig}>
      <ErrorBoundary>
        <Router>
          <AnalyticsWrapper>
            <PageRouteProvider>
              <UserProvider>
                <NavigationProvider>
                  <NotificationProvider>
                    <ToastProvider>
                      <AppLayout>
                        <AppRoutes />
                      </AppLayout>
                    </ToastProvider>
                  </NotificationProvider>
                </NavigationProvider>
              </UserProvider>
            </PageRouteProvider>
          </AnalyticsWrapper>
        </Router>
      </ErrorBoundary>
    </Provider>
  );

};

export default hot(App);
